/* eslint-disable import/prefer-default-export */
export const entityTypesParserMixin = {
  methods: {
    getTypeName(value, store) {
      if (!value) return 'Unknown';
      if (!store.state.entityTypes) return 'Unknown';
      // find!
      let rv = store.getters.allEntityTypes.find(v => v.id == value);
      if (!rv) {
        rv = store.getters.allEntityTypes.find(v => v.shortcode == value)
      }
      return rv ? rv.name : 'Unknown';
    }
  }
}
